/* Copyright 2022 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _IdManager_id;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { AnnotationEditorPrefix } from "../shared/utils";
export class IdManager {
    constructor(idPrefix = AnnotationEditorPrefix) {
        _IdManager_id.set(this, 0);
        this.idPrefix = AnnotationEditorPrefix;
        // if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("TESTING")) {
        Object.defineProperty(this, "reset", {
            value: () => (__classPrivateFieldSet(this, _IdManager_id, 0, "f"))
        });
        // }
        this.idPrefix = idPrefix;
    }
    get id() {
        var _a, _b;
        return `${this.idPrefix}${__classPrivateFieldSet(this, _IdManager_id, (_b = __classPrivateFieldGet(this, _IdManager_id, "f"), _a = _b++, _b), "f"), _a}`;
    }
}
_IdManager_id = new WeakMap();
